import Vue from './vue'

import './vvuejs.parcel.scss'

export * from './utils.mjs'
export * from './vueRegister.mjs'

import './directives/resizeObserver.js'

// import '/vodalys/vfigma/vfigma.parcel.mjs' // ca fait quoi ici ce truc ?

import './vvuejs.parcel.angularFilters.mjs'
import './filters/*.mjs'

import { registerAngularModule } from '/vodalys/vparcel/source.init.mjs'

import { vWrapperModule } from './vvuejs.parcel.vWrapper.mjs'

import VueAngularPlaceHolder from './vvuejs.parcel.angularPlaceHolder.mjs'
Vue.component('VueAngularPlaceHolder', VueAngularPlaceHolder)

export const vVuejsModule = angular.module('vvuejs.vconsole', [vWrapperModule.name, 'vvuejs.angularPlaceHolder', 'vvuejs.vrunAngularPlaceholder'])
registerAngularModule(vVuejsModule.name)

import VuePlaceholder from './vvuejs.parcel.vuePlaceholder.mjs'
Vue.component('VuePlaceholder', VuePlaceholder)

import VrunPlaceholder from './components/VrunPlaceholder.vue'
Vue.component('VrunPlaceholder', VrunPlaceholder)

import VrunAngularPlaceholder from './components/VrunAngularPlaceholder.vue'
Vue.component('VrunAngularPlaceholder', VrunAngularPlaceholder)


let angularInjector;

vVuejsModule.run(function ($injector) {
    angularInjector = $injector
})

export function angularInvoke(fn) {
    return angularInjector.invoke(fn)
}
export async function asyncAngularInvoke(fn) {

    if (angularInjector) {
        return angularInjector.invoke(fn)
    }

    const $injector = await new Promise(resolve => {
        vVuejsModule.run(function ($injector) {
            resolve($injector)
        })
    })
    return $injector.invoke(fn)
}
